export default "__VITE_ASSET__79ce7ca7__"